import React from "react";
import RefundImg1 from "../../assets/images/RefundImg1.svg";
import RefundImg2 from "../../assets/images/RefundImg2.svg";
import RefundImg3 from "../../assets/images/RefundImg3.svg";

import styles from "./PoliciesAndTerms.module.css";

export default function RefundPolicy() {
  return (
    <section
      className={`${styles.termsBlockContainer} ${styles.memberPolicies} ${styles.noBg}`}
    >
      <div className={styles.container}>
        <h3>
          Refund & <span> Cancellation Policy</span>
        </h3>
        <h5>
          Clear, transparent guidelines governing membership fees, event
          registrations, and service cancellations.
        </h5>
        <div className={styles.cards}>
          <div className={styles.card}>
            <div className={styles.heading}>
              <figure className={styles.maxWidth1}>
                <img src={RefundImg1} alt={"Author Membership"} />
              </figure>
              <h4>Membership Fees</h4>
            </div>
            <ul>
              <li>
                <h6>Full Refund (Within 30 Days)</h6>
                <p>
                  A complete refund may be issued for written cancellation requests submitted within 30 days of membership registration, provided no core benefits have been substantially utilized.
                </p>
              </li>
              <li>
                <h6>Partial Refund (31-60 Days)</h6>
                <p>A 50% refund may be granted for cancellations requested between 31-60 days from registration.</p>
              </li>
              <li>
                <h6>No Refund (After 60 Days)</h6>
                <p>
                 No refund shall be applicable for cancellation requests received after 60 days from the date of registration.
                </p>
              </li>
              <li>
                <h6>Processing Timeline</h6>
                <p>Approved refunds will be processed within 7-10 business days through the original mode of payment.</p>
              </li>
            </ul>
          </div>
          <div className={styles.card}>
            <div className={styles.heading}>
              <figure className={styles.maxWidth1}>
                <img src={RefundImg2} alt={"Event Registrations"} />
              </figure>
              <h4>Event Registrations</h4>
            </div>
            <ul>
              <li>
                <h6>Early Cancellation</h6>
                <p>
                 Full refund minus applicable administrative processing fee for cancellations made 15 days or more prior to the event.
                </p>
              </li>
              <li>
                <h6>Late Cancellation</h6>
                <p>A partial refund (up to 25%) may be considered for cancellations made 7-14 days before the event.</p>
              </li>
              <li>
                <h6>No-Show Policy</h6>
                <p>No refund will be issued for non-attendance or cancellations made within 7 days of the event.</p>
              </li>
              <li>
                <h6>Event Cancellation by IMPARC</h6>
                <p>In the event of cancellation by IMPARC, participants will be eligible for a full refund or credit transfer to a future event.</p>
              </li>
            </ul>
          </div>
          <div className={styles.card}>
            <div className={styles.heading}>
              <figure className={styles.maxWidth1}>
                <img src={RefundImg3} alt={"Service Cancellations"} />
              </figure>
              <h4>Service Cancellations</h4>
            </div>
            <ul>
              <li>
                <h6>Mentorship Programs</h6>
                <p>
                  Pro-rated refunds may be considered based on unused sessions, subject to a minimum 48-hour prior notice.
                </p>
              </li>
              <li>
                <h6>Consultation Services</h6>
                <p>Full refund may be granted for cancellations made at least 24 hours in advance.</p>
              </li>
              <li>
                <h6>Force Majeure</h6>
                <p>
                 Refunds or credits may be evaluated on a case-by-case basis in situations involving unforeseen circumstances beyond reasonable control.
                </p>
              </li>
              <li>
                <h6>Dispute Resolution</h6>
                <p>Any refund-related disputes shall be reviewed and resolved through the IMPARC governance and grievance redressal mechanism.</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
